//#region Imports
import { Component, OnInit } from '@angular/core';
import { DialogService } from '@app/core/services/dialog-service.service';
import { InactivityTimerService } from '@app/core/services/inactivity-timer.service';
import { TIMER_OPTIONS } from '@app/member-response-portal/model/constants';
//#endregion Imports
@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent  implements OnInit {
    //#region Public Variables
    public CountDownTime : number = TIMER_OPTIONS.MINUTES_1;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    private DialogTimer: any;
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(
        private dialogService: DialogService,
        private inactivityTimerService: InactivityTimerService
      ){}

    public ngOnInit(): void {
        if(this.DialogTimer){
            this.StopCountdown()
        }
        this.StartCountDown();
    }
    //#endregion Constructor

    //#region Public Methods
    public OnClickRedirectToLogin(): void {
        this.inactivityTimerService.LogoutAndRedirectToLogin();
        this.StopCountdown();
    }

    public OnClickKeepWorking(): void {
        this.inactivityTimerService.ContinueSession();
        this.StopCountdown();
    }
    //#endregion Public Methods

    //#endregion Private Methods
    private StartCountDown(): void {
        this.DialogTimer = setInterval(() => {
            this.CountDownTime--;

            if (this.CountDownTime <= 0) {
                this.StopCountdown();
                this.inactivityTimerService.ShowInactivityLogOutDialog();
            }
        }, 1000);
    }

    private StopCountdown(): void {
        clearInterval(this.DialogTimer);
        this.DialogTimer = null;
        this.dialogService.CloseDialog();
    }
    //#endregion Private Methods
}
